import { PlusCircleOutlined } from '@ant-design/icons'
import { useGetLabelMasterById } from 'src/features/labelCheck/hooks/useGetLabelMasterById'

type Props = {
  labelMasterId?: string
}

// ラベルマスタを選択していたら名前と管理番号を表示する。
// 選択していない場合は「検査を指定する」と表示する。
export const SelectLabelMasterOptionMessage = ({ labelMasterId }: Props) => {
  const labelMaster = useGetLabelMasterById(labelMasterId)

  return labelMaster ? (
    <>
      {labelMaster.name}
      {labelMaster.code ? `(${labelMaster.code})` : ''}
    </>
  ) : (
    <>
      <PlusCircleOutlined /> 検査を指定する
    </>
  )
}
